"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StocksModule = void 0;
const router_1 = require("client/components/router");
const sites_detail_1 = require("./modules/sites-detail");
const sites_list_1 = require("./modules/sites-list");
class StocksModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/lots\/pharmacies\/?$/, sites_list_1.SitesList);
        this.addRoute("detail", /^\/lots\/pharmacies\/(\d+)/, sites_detail_1.SitesDetail);
    }
}
exports.StocksModule = StocksModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/stocks.tsx
// module id = 4093
// module chunks = 0